// removed by extract-text-webpack-plugin
module.exports = {"totheleft":"_2WVf4ximWDvwjMPMqhfT3G_0","custom-control":"_3mLMaSBJHkzabU8svGib4P_0","form-group":"_1bTNuY9HdS5xYska_vLufJ_0","required":"_2PB7EPpPf2DWkRUo6GNjRf_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ac2cb76","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ResourceEdit.vue
// module id = Y2GF
// module chunks = 1